// extracted by mini-css-extract-plugin
module.exports = {"editorWidgets":"EditorWidgets_editor-widgets__PhYxq"};